






































































































import dayjs from 'dayjs'
import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import { ManagerReportType } from '../../types'
import CDatePicker from '../inputs/CDatePicker.vue'
import MainMixin from '../../mixins/MainMixin'

@Component({
  components: {
    CDatePicker,
  },
})
export default class ManagerReport extends Mixins(MainMixin) {
  @Prop() users!:any

  managerShifts = [
    'AM Shift', 'PM Shift', 'Both Shifts',
  ]

  numberEmployees = 0

  selectedDate = ''

  selectedTime = ''

  refreshKey = 0

  loadNew = false

  get date() {
    const date = dayjs(this.selectedDate).hour(Number(this.selectedTime.split(':')[0])).minute(Number(this.selectedTime.split(':')[1]))
    return date
  }

  data:ManagerReportType = {
    user: this.$store.getters.multiUser ? '' : this.$store.getters.uid,
    date: dayjs(new Date()).format('YYYY-MM-DD'),
    shift: '',
    foh: '',
    boh: '',
    employees: [],
    complaints: '',
    notes: '',
  }

  presubmit() {

  }

  setLocalStorage() {
    const d = Object.assign(this.data, { numberEmployees: this.numberEmployees })
    window.localStorage.setItem(`${this.$store.getters.location}-mreportdata`, JSON.stringify(d))
  }

  getLocalStorage() {
    this.data.employees = []
    // this.loadNew = true
    const item = window.localStorage.getItem(`${this.$store.getters.location}-mreportdata`)
    console.log('here getting: ', `${this.$store.getters.location}-mreportdata`, ' ', item)
    if (!item) this.clearForm()
    else {
      // this.numberEmployees = 100
      console.log('item is: ', item)
      const dd = JSON.parse(item)
      console.log('dd is: ', dd)
      this.numberEmployees = dd.numberEmployees || 0
      delete dd.numberEmployees
      // this.data.employees =
      console.log('xd: ', this.numberEmployees)
      this.data = dd
      this.refreshKey += 1
    }
    // this.loadNew = false
  }

  blankData() {
    return {
      user: this.$store.getters.multiUser ? '' : this.$store.getters.uid,
      date: dayjs(new Date()).format('YYYY-MM-DD'),
      shift: '',
      foh: '',
      boh: '',
      employees: [],
      complaints: '',
      notes: '',
    }
  }

  clearForm() {
    window.localStorage.removeItem(`${this.$store.getters.location}-mreportdata`)
    this.numberEmployees = 0
    this.data = this.blankData()
    this.selectedDate = ''
    const observer:any = this.$refs.obs
    const datePicker:any = this.$refs.datepicker;
    ([datePicker, observer]).forEach((x) => {
      if (x) x.reset()
    })
  }

  // @Watch('numberEmployees')
  // changedComps(newNumberEmployees:number) {
  //   // if (!this.loadNew) {
  //   console.log('going now', newNumberEmployees)
  //   console.log('thisd data empl', this.data.employees)
  //   if (newNumberEmployees > this.data.employees.length) {
  //     const diff = newNumberEmployees - this.data.employees.length
  //     if (diff === 1) {
  //       this.data.employees.push({ user: '', rating: 0, note: '' })
  //       // diff -= 1
  //     }
  //   } else this.data.employees.pop()
  //   // }
  // }

  addEmployee() {
    this.data.employees.push({ user: '', rating: 0, note: '' })
    this.numberEmployees += 1
  }

  removeEmployee() {
    if (this.numberEmployees !== 0) {
      this.data.employees.pop()
      this.numberEmployees -= 1
    }
  }


  @Watch('data.date')
  dateChange(newDate:string) {
    this.data.date = newDate
  }

  @Watch('selectedDate')
  newDateChange(d:string) {
    console.log('now new date', d)
    this.data.date = d
  }

  // created() {
  //   // this.getLocalStorage()
  //   console.log('success - ', this.data)
  //   if (!this.$store.getters.multiUser) {
  //     this.data.user = this.$store.getters.uid
  //   }
  //   setInterval(() => {
  //     console.log('NOW100')
  //     this.setLocalStorage()
  //   }, 10000)
  // }
}

